import { DispatchType, StoreAction, StoreState } from "../reduxTypes";
import { Error202, parseError } from "../../utils/http-helper";
import impostoRendaService from "../../services/ImpostoRenda";
import { getSession } from "../../utils/session-helper";

export const IMPOSTO_RENDA__INICIALIZA_ESTADO =
  "IMPOSTO_RENDA__INICIALIZA_ESTADO";
export const IMPOSTO_RENDA__SET_DADOS_IR = "IMPOSTO_RENDA__SET_DADOS_IR";
export const IMPOSTO_RENDA__SET_ANOS = "IMPOSTO_RENDA__SET_ANOS";
export const IMPOSTO_RENDA__SET_FILTROS = "IMPOSTO_RENDA__SET_FILTROS";
export const IMPOSTO_RENDA__LIMPAR_FILTROS = "IMPOSTO_RENDA__LIMPAR_FILTROS";
export const IMPOSTO_RENDA__SET_LOADING = "IMPOSTO_RENDA__SET_LOADING";

function setFiltros(dados: { ano: string }): StoreAction {
  return {
    type: IMPOSTO_RENDA__SET_FILTROS,
    payload: dados,
  };
}

function setDadosIR(dados: Object): StoreAction {
  return {
    type: IMPOSTO_RENDA__SET_DADOS_IR,
    payload: dados,
  };
}

function setAnos(dados: Object): StoreAction {
  return {
    type: IMPOSTO_RENDA__SET_ANOS,
    payload: dados,
  };
}

function setRequisitado(): StoreAction {
  return { type: IMPOSTO_RENDA__INICIALIZA_ESTADO };
}

function limparFiltros(): StoreAction {
  return { type: IMPOSTO_RENDA__LIMPAR_FILTROS };
}

function setLoading(l: boolean): StoreAction {
  return {
    type: IMPOSTO_RENDA__SET_LOADING,
    payload: l,
  };
}

function buscarAnos() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    // dispatch(startLoading());

    return impostoRendaService
      .buscarAnos(userData.CPF)
      .then((resp) => {
        const { data } = resp;

        if (typeof data === typeof []) {
          dispatch(setAnos(data));
          if (data.length > 0) {
            dispatch(setFiltros({ ano: data[1].toString() }));
          }
        } else {
          dispatch(setAnos([]));
          dispatch(setFiltros({ ano: "0" }));
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => {});
  };
}

function buscarDemonstrativoIR(ano: string) {
  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));
    return impostoRendaService
      .buscarDemonstrativo(userData.CPF, ano)
      .then((resp) => {
        const { data } = resp;

        dispatch(setDadosIR(typeof data === typeof [] ? data : []));
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

function inicializaEstado() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    try {
      const {
        impostoRendaState: { filtros, requisitado },
      } = getState();
      const filtrosIniciais = { ...filtros };
      if (!requisitado) {
        dispatch(setRequisitado());
      }
      const { data: respAnos } = await impostoRendaService.buscarAnos(
        userData.CPF
      );

      if (typeof respAnos === typeof []) {
        dispatch(setAnos(respAnos));

        if (respAnos.length > 0) {
          filtrosIniciais.ano = respAnos[0].toString();

          impostoRendaService
            .buscarDemonstrativo(userData.CPF, filtrosIniciais.ano)
            .then((resp) => {
              const { data: dadosExtrato } = resp;
              dispatch(setDadosIR(dadosExtrato));
            });

          dispatch(setFiltros(filtrosIniciais));
        }
      } else {
        throw new Error202("Nenhuma Lotação encontrada no período");
      }
      dispatch(setFiltros(filtrosIniciais));
    } catch (erro) {
      parseError(erro, "Erro ao tentar conectar");
    }
  };
}

const impostoRendaActions = {
  inicializaEstado,
  setFiltros,
  limparFiltros,
  buscarAnos,
  buscarDemonstrativoIR,
};

export default impostoRendaActions;
